import { useEffect } from "react"

import { useLazyGetFeatureFlagsQuery } from "store/api/featureFlagsApi"
import { setEnabledFeatureFlags } from "store/featureFlagsSlice"
import { useAppDispatch, useAppSelector } from "store/hooks"
import { StorageKeys } from "types/enums/StorageKeys"

import { setStorageItem } from "utils/localStorage"

export const useLoadFeatureFlags = () => {
  const dispatch = useAppDispatch()
  const isUserAuthorized = useAppSelector(state => state.user.isUserAuthorized)
  const [triggerGetFeatureFlags] = useLazyGetFeatureFlagsQuery()

  useEffect(() => {
    const loadFeatureFlags = async () => {
      if (!isUserAuthorized) return
      try {
        const res = await triggerGetFeatureFlags()
        const flags = res?.data?.data
        if (!flags) return
        const enabled = Object.entries(flags)
          .filter(([, value]) => value?.enabled)
          .map(([key]) => key)
        setStorageItem(StorageKeys.EnabledFeatureFlags, enabled)
        dispatch(setEnabledFeatureFlags(enabled))
      } catch (error) {
        console.error("Failed to load feature flags:", error)
      }
    }

    loadFeatureFlags()
  }, [isUserAuthorized, triggerGetFeatureFlags, dispatch])
}
